import { render } from "./DaftarAgenda.vue?vue&type=template&id=1faaa77a"
import script from "./DaftarAgenda.vue?vue&type=script&lang=js"
export * from "./DaftarAgenda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__